import SeoHead from '../../components/SeoHead';
import { Global, Jobs, Collection } from '@sourceflow-uk/sourceflow-sdk';
import React from 'react';
import {
    Container,
    Row,
    Col
} from 'reactstrap';
import Link from 'next/link';
import SubBanner from '../../components/SubBanner';
import TextWithCTA from '../../components/TextWithCTA';
import LatestJobs from '../../components/LatestJobs';
import OurBranches from '../../components/OurBranches';
import SimplePage from '../../components/SimplePage';
import SimpleTwoColumns from '../../components/SimpleTwoColumns';
import SimpleImageWithText from '../../components/SimpleImageWithText';
import Header from '../../components/MainHeader';

export default function GapPersonnelCareers({
    global,
    all_jobs,
    all_jobs_search_by_client
}) {
    return (
        <>
            <SeoHead
                // site_name={`Driving Force`}
                page_name={`Gap Personnel Careers | Gap Personnel`}
                // description={``}
                canonical_link={`/gap-personnel-careers/`}
            />
            <Header
                employerNav={false}
            />
            <SubBanner
                global={global}
                pathPrefix={`dfr_careers_page.sub_banner`}
                customClass={`mb-5 secondary-banner`}
                buttonTitle={`Jobseekers / Opportunities`}
                buttonLink={`/job-seekers/`}
                heading={`Opportunities`}
                bannerImageAlt={`Gap Personnel Banner Image`}
                bannerImageAlt2={`Gap Personnel Banner Image 2`}
                bannerImage={`/site-assets/images/dfr-career-img-1.jpg`}
                bannerImage2={`/site-assets/images/dfr-career-img-2.jpg`}
                dualBannerImage={true}
                MainButtonTitle={``}
                MainButtonLink={``}
            />
            <TextWithCTA
                global={global}
                pathPrefix={`dfr_careers_page.text_with_cta`}
                customClass={`mt-5 pt-5 mb-3 pb-lg-5`}
                link1={`/job-seekers-get-in-touch`}
                link2={`/recruit-staff/`}
                column1={true}
                column2={false}
                buttonTitle1={
                    <>
                        <strong>
                            Get a callback
                        </strong> and we'll help you find your next role
                    </>
                }
                buttonTitle2={
                    <>
                        <strong>
                            Recruit staff
                        </strong> let us help your fill your next role
                    </>
                }
                fullWidth={true}
                mainButtonTitle1={`Get in touch`}
                mainButtonLink1={`/job-seekers-get-in-touch/`}
            />
            <SimpleTwoColumns
                global={global}
                pathPrefix={`dfr_careers_page.simple_two_columns`}
                customClass={`mb-5`}
                content1={
                    <>
                        <p><strong>‘As our business grows, so does our need for great people to join us’</strong></p>
                        <p>It’s hardly surprising that happy employees stay in their job an average four times longer than their unhappy counterparts. It’s one of the reasons we work hard to create a fun, supportive workplace where our employees can thrive.</p>
                    </>
                }
                content2={
                    ``
                }
                bottomBannerCTA={true}
                buttomBannerCTALINK={`/jobs/internal/`}
                buttomBannerCTATitle={`join gap personnel`}
            />
            <SimpleImageWithText
                global={global}
                pathPrefix={`careers_page.simple_image_with_text`}
                customClass={` mb-5 pb-5 mt-5 pt-4`}
                content1={
                    <>
                        <h2>Benefits</h2>
                        <p>So, the core values sound like a good fit for you – but what else is on offer?</p>
                        <ul>
                            <li>25 days holidays plus bank holidays</li>
                            <li>An additional ½ day on your birthday</li>
                            <li>Vouchers on your work anniversary to say thank you from us</li>
                            <li>Industry-leading bonus scheme</li>
                            <li>Private medical insurance (after qualifying period)</li>
                            <li>Cycle to work scheme</li>
                            <li>Annual company awards event</li>
                        </ul>
                        <p>What are you waiting for? We’d love to hear from you.</p>
                        <p>*An additional 1/2 day holiday on your birthday</p>
                    </>
                }
                imageAltText={`Gap Personnel Careers Benefits Image`}
                imageUrl={"/site-assets/images/our-benefits.jpg"}
            />
            <LatestJobs
                global={global}
                pathPrefix={`dfr_careers_page.latest_jobs`}
                customClass={`mt-3 mb-5`}
                heading={`Internal Vacancies`}
                subtitle={`jobseekers`}
                all_jobs={all_jobs}
                label={false}
                headingFullWidth={true}
                headingTextCenter={true}
            />
            <OurBranches
                global={global}
                pathPrefix={`dfr_careers_page.our_branches`}
                customClass='mt-5'
                heading={`Our branches`}
                content={`
                Operating from one of our five regional branches across England, our consultants are on hand to offer tailored support and local knowledge for all your driver recruitment needs.
                `}
                buttonTitle={`Our locations`}
                buttonLink={`/job-seekers-get-in-touch/`}
            />
            <SimplePage
                global={global}
                pathPrefix={`dfr_careers_page.simple_page_1`}
                customClass={``}
                content={``}
                formId={`2b1903d0-c09a-4b34-9c3b-27a7b7afb573`}
                heading={`Get in touch`}
                textCenter={true}
            />
        </>
    );
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();
    const jobs_search_by_client = await Collection('jobs_search_by_client');

    const all_jobs_search_by_client = jobs_search_by_client.orderBy('order').getItems();
    const all_jobs = (await Jobs())
        .filter(function (job) {
            return job.categories
                // Pulls all internal jobs
                .find((cat) => cat.id === "eabbc9bc-c6e8-4bd0-861d-b129f5218f97");
        })
        .filter(function (job) {
            return (
                (new Date(job?.expires_at)) >= (new Date())
            )
        })
        .getItems().slice(0, 8);

    return {
        props: {
            global,
            all_jobs,
            all_jobs_search_by_client
        },
    }
}